import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import useBrainstormStore from "../../../hooks/useBrainstormStore";
import BrainstormConceptsEditTemplate from "../../Templates/BrainstormConceptsEdit";
import { getBrainstormById } from "../../../services/Brainstorm/BrainstormService";

export default function BrainstormConceptsEditPage() {
    const { projectId, outputId } = useParams();
    const { keycloak } = useKeycloak();
    const navigate = useNavigate();
    const {
        clearBrainstormsByProject
    } = useBrainstormStore();

    const KEYCLOACK_TOKEN = keycloak.token;

    const [currentBrainstorm, setCurrentBrainstorm] = useState(null);	
    const [hasError, setHasError] = useState(false);
    const [isLoadingFromApi, setIsLoadingFromApi] = useState(false);

    useEffect(() => {
        const loadBrainstormFromApi = async () => {
            if (!outputId || !KEYCLOACK_TOKEN) return;

            setIsLoadingFromApi(true);
            setHasError(false);

            try {
                const brainstormData = await getBrainstormById(outputId, KEYCLOACK_TOKEN);

                
                if (!brainstormData || !brainstormData.data) {
                    Swal.fire({
                        title: 'Erro',
                        text: 'Brainstorm não encontrado.',
                        timer: 2000,
                        showConfirmButton: false,
                        background: '#27272A',
                        color: '#fff',
                        position: 'top-end',
                    });
                    navigate(`/project/${projectId}`);
                    return;
                }
                
                const apiData = brainstormData.data;

                const ideasArray = Object.values(apiData.ideas);

                const ideasById = Object.fromEntries(
                    ideasArray.map(idea => [idea.id, idea])
                )

                const guidingQuestionsArray = Object.values(apiData.guiding_questions);

                const guidingQuestionsWithUpdatedIdeas = guidingQuestionsArray.map(gq => ({
                    ...gq,
                    ideas: gq.ideas
                      .map(ideaStub => ideasById[ideaStub.id])
                      .filter(Boolean) // safety: removes missing ids
                }))

                const transformedData = {
                    challenges: Array.isArray(apiData.challenges) ? apiData.challenges : Object.values(apiData.challenges || {}),
                    guiding_questions: guidingQuestionsWithUpdatedIdeas || [],
                    ideas: apiData.ideas || [],
                    groups: apiData.groups || [],
                    concepts: apiData.concepts || [],
                    createdAt: apiData.createdAt || new Date().toISOString(),
                    updatedAt: apiData.updatedAt || new Date().toISOString(),
                    step: apiData.step || 3 // Concepts step
                };

                // Clear existing brainstorms in the store for this project to avoid conflicts
                clearBrainstormsByProject(parseInt(projectId));

                setCurrentBrainstorm(transformedData);
            } catch (error) {
                setHasError(true);
                console.error('Error loading brainstorm data from API:', error);
                Swal.fire({
                    title: 'Ocorreu um erro',
                    text: 'Erro ao carregar dados do brainstorm. Tente novamente mais tarde',
                    timer: 2000,
                    showConfirmButton: false,
                    background: '#27272A',
                    color: '#fff',
                    position: 'top-end',
                });
                navigate(`/project/${projectId}`);
            } finally {
                setIsLoadingFromApi(false);
            }
        };

        loadBrainstormFromApi();
    }, [outputId, KEYCLOACK_TOKEN, projectId, navigate, clearBrainstormsByProject]);

    return (
        <BrainstormConceptsEditTemplate 
            data={currentBrainstorm}
            loadingData={isLoadingFromApi} 
            hasError={hasError} 
        />
    );
}